import "./ContactSection.css";

const clinicAddress = "Fizion Gyógytorna, 1048 Budapest, Székpatak utca 6";
const googleMapsQuery = encodeURIComponent(clinicAddress);
const googleMapsEmbedUrl = `https://maps.google.com/maps?q=${googleMapsQuery}&t=&z=16&ie=UTF8&iwloc=B&output=embed`;

function ContactSection() {
  return (
    <section className="section" id="kapcsolat">
      <div className="contact-layout">
        <div>
          <p className="eyebrow">Kapcsolat</p>
          <h2>Foglalj időpontot vagy kérdezz bátran!</h2>
          <div className="contact-list">
            <p>Mayer Nikolett</p>
            <a href="tel:+36209077705">+36 20 907 7705</a>
            <a href="mailto:info@fiziongyogytorna.hu">
              info@fiziongyogytorna.hu
            </a>
            <p>{clinicAddress}</p>
            <p>
              Tegye meg az első lépést a biztonságos, hatékony felépülésért.
              Keress bizalommal!
            </p>
          </div>
        </div>

        <div className="contact-card">
          <div className="contact-map">
            <iframe
              title="Fizion Gyógytorna térkép"
              src={googleMapsEmbedUrl}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export default ContactSection;
